/* eslint-disable import/prefer-default-export */
import { Span, TraceFlags } from "@opentelemetry/api";
import { ReadableSpan } from "@opentelemetry/sdk-trace-web";
import { SentrySpanProcessor } from "@sentry/opentelemetry";

export class FilterableSentrySpanProcessor extends SentrySpanProcessor {
  private readonly filter: (span: Span & ReadableSpan) => boolean;

  constructor(filter: (span: Span & ReadableSpan) => boolean) {
    super();
    this.filter = filter;
  }

  onEnd(span: Span & ReadableSpan): void {
    if (this.filter(span)) {
      // eslint-disable-next-line no-param-reassign
      span.spanContext().traceFlags = TraceFlags.NONE;
      super.onEnd(span);
    }
  }
}
